<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  width: 100%;
  font-family: Arial, sans-serif;
}

/* Основные стили для body */
body {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f2f5;
  overflow-x: hidden;
}

/* Обеспечение того, что контент займет всю высоту и ширину */
#app {
  width: 100%;
  height: 100%;
}
</style>